import { createSelector } from '@reduxjs/toolkit'

import { Activities, TaskDomain } from './dashboard-slice'

import { AppRootState } from 'app/store'

export const selectCategories = (state: AppRootState) => state.dashboard.categories

export const selectSearchText = (state: AppRootState) => state.dashboard.search

export const selectCategory = (state: AppRootState, id: string) =>
  state.dashboard.categories.find(category => category.id === id)

export const selectCategoryByTaskId = (state: AppRootState, id: string) => {
  return state.dashboard.categories.find(category => category.tasks.some(task => task.id === id))
}

export const selectTaskByTaskId = (state: AppRootState, id: string) => {
  const categories = state.dashboard.categories

  for (let i = 0; i < categories.length; i++) {
    const task = categories[i].tasks.find(task => task.id === id)

    if (task) return task
  }
}

export const selectNextTaskId = (state: AppRootState, categoryId: string, taskId: string) => {
  const tasks = state.dashboard.categories?.find(category => category.id === categoryId)?.tasks
  const currentIndex = tasks?.findIndex(task => task.id === taskId)

  return currentIndex === tasks!.length - 1 ? tasks![0].id : tasks![currentIndex! + 1].id
}

export const selectCategoriesBySearch = createSelector(
  [selectCategories, selectSearchText],
  (categories, searchText) => {
    if (searchText === '') return categories
    const text = searchText.toLowerCase()

    return categories
      .map(category => ({
        ...category,
        tasks: category.tasks.filter(task => task.title.toLowerCase().includes(text)),
      }))
      .filter(category => category.tasks.length !== 0)
  }
)

export const selectActivityData = createSelector(selectCategories, (categories): ActivityData => {
  return categories.map(category => ({
    id: category.id,
    activities: category.activities,
    tasks: category.tasks.map(task => ({
      id: task.id,
      activities: task.activities,
    })),
  }))
})

export type ActivityData = Array<{
  id: string
  activities: Activities
  tasks: Pick<TaskDomain, 'id' | 'activities'>[]
}>
